import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth, isAdmin } from "./context/AuthContext";
import { HomeownerLayout } from "./components/HomeownerLayout";
import { AdminLayout } from "./components/AdminLayout";
import { Loader } from "./components/Loader";

import Login from "./pages/Login";
import Landing from "./pages/Landing";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Build from "./pages/Build";
import MyHome from "./pages/MyHome";
import Documents from "./pages/Documents";
import Warranty from "./pages/Warranty";
import Service from "./pages/Service";
import ServiceNew from "./pages/ServiceNew";
import ServiceDetail from "./pages/ServiceDetail";
import Updates from "./pages/Updates";
import Account from "./pages/Account";

import AdminDashboard from "./pages/admin/AdminDashboard";
import Properties from "./pages/admin/Properties";
import PropertyDetail from "./pages/admin/PropertyDetail";
import Homeowners from "./pages/admin/Homeowners";
import Contractors from "./pages/admin/Contractors";
import AdminService from "./pages/admin/AdminService";
import AdminServiceDetail from "./pages/admin/AdminServiceDetail";

function Protected({ children, admin }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen bg-arq-bg"><Loader label="ARQITRAK" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !isAdmin(user)) return <Navigate to="/dashboard" replace />;
  if (!admin && isAdmin(user)) return <Navigate to="/admin" replace />;
  return children;
}

function HO({ children }) { return <Protected><HomeownerLayout>{children}</HomeownerLayout></Protected>; }
function AD({ children }) { return <Protected admin><AdminLayout>{children}</AdminLayout></Protected>; }

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen bg-arq-bg"><Loader label="ARQITRAK" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={isAdmin(user) ? "/admin" : "/dashboard"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/dashboard" element={<HO><Dashboard /></HO>} />
          <Route path="/build" element={<HO><Build /></HO>} />
          <Route path="/home" element={<HO><MyHome /></HO>} />
          <Route path="/documents" element={<HO><Documents /></HO>} />
          <Route path="/warranty" element={<HO><Warranty /></HO>} />
          <Route path="/service" element={<HO><Service /></HO>} />
          <Route path="/service/new" element={<HO><ServiceNew /></HO>} />
          <Route path="/service/:id" element={<HO><ServiceDetail /></HO>} />
          <Route path="/updates" element={<HO><Updates /></HO>} />
          <Route path="/account" element={<HO><Account /></HO>} />

          <Route path="/admin" element={<AD><AdminDashboard /></AD>} />
          <Route path="/admin/properties" element={<AD><Properties /></AD>} />
          <Route path="/admin/properties/:id" element={<AD><PropertyDetail /></AD>} />
          <Route path="/admin/homeowners" element={<AD><Homeowners /></AD>} />
          <Route path="/admin/contractors" element={<AD><Contractors /></AD>} />
          <Route path="/admin/service" element={<AD><AdminService /></AD>} />
          <Route path="/admin/service/:id" element={<AD><AdminServiceDetail /></AD>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
